import { render, staticRenderFns } from "./ChatForwardWindow.vue?vue&type=template&id=13ed8b74&scoped=true"
import script from "./ChatForwardWindow.vue?vue&type=script&lang=js"
export * from "./ChatForwardWindow.vue?vue&type=script&lang=js"
import style0 from "./ChatForwardWindow.vue?vue&type=style&index=0&id=13ed8b74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed8b74",
  null
  
)

export default component.exports